'use client';

import { c as _c } from "react/compiler-runtime";
import useShouldReceiveNotification from '@module/stores/useShouldReceiveNotification';
import { useEffect } from 'react';
import SettingConfig from '../config/setting';
import { aspCond } from '../helpers/conditions/condition';
import { PushNotification } from './PushNotification';
const checkHasFirebaseRegistration = async () => {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      return regs.some(reg => reg.active?.scriptURL.includes('firebase-messaging-sw'));
    }
    return false;
  } catch (error) {
    console.error('Error checking Firebase registration:', error);
    return false;
  }
};
function HandleAllowNotificationExecutor() {
  const $ = _c(4);
  const {
    shouldReceiveNoti
  } = useShouldReceiveNotification();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp4, t0);
  let t1;
  let t2;
  if ($[1] !== shouldReceiveNoti) {
    t1 = () => {
      const handlePushNotificationStatus = async () => {
        ;
        try {
          if (shouldReceiveNoti === "Y") {
            new PushNotification().pushReqEvent("register");
          } else {
            if (shouldReceiveNoti === "N") {
              const hasRegistration = await checkHasFirebaseRegistration();
              if (hasRegistration) {
                new PushNotification().pushReqEvent("unregister");
              }
            }
          }
        } catch (t3) {
          const error = t3;
          console.error("Error handling push notification:", error);
        }
      };
      const timer_0 = setTimeout(handlePushNotificationStatus, 2000);
      return () => {
        clearTimeout(timer_0);
      };
    };
    t2 = [shouldReceiveNoti];
    $[1] = shouldReceiveNoti;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
}
function _temp4() {
  const checkServiceWorker = _temp3;
  const timer = setTimeout(() => {
    checkServiceWorker();
  }, 600);
  return () => {
    clearTimeout(timer);
  };
}
function _temp3() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistration().then(_temp2);
  }
}
function _temp2(registration) {
  if (registration) {
    const registeredScriptURL = registration?.active?.scriptURL;
    const targetScriptURL = `${window.location.origin}/firebase-messaging-sw.js?js=${SettingConfig.CURRENT_SITE}`;
    if (registeredScriptURL !== targetScriptURL) {
      PushNotification.expireRemainingToken().then(() => {
        registration.unregister().then(_temp);
      });
    }
  } else {
    console.info("no Service Worker registered");
  }
}
function _temp(success) {
  console.info(success ? "\uAE30\uB4F1\uB85D Service Worker \uC0AD\uC81C \uC131\uACF5" : "\uAE30\uB4F1\uB85D Service Worker \uC0AD\uC81C \uC2E4\uD328");
}
export function HandleAllowNotification() {
  const $ = _c(1);
  if (aspCond.if("asp")) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <HandleAllowNotificationExecutor />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}